import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button} from "reactstrap"
import {getExportOrdersCSVv41} from "../../../services/api/apiBarcode"

function cleanObjectShallow(obj) {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, v]) =>
      !(v === "" || v === null || v === undefined || (Array.isArray(v) && v.length === 0))
    )
  )
}

class ExportOrders extends Component {
    _exportOrders = async () => {
        try {
            const {filter} = this.props

            let tagsExport = []
            if(filter.tags)  tagsExport.push(...filter.tags)
            if(filter.list_tags) tagsExport.push(...filter.list_tags)

            const filterTags = {
                tags: tagsExport
            }
            
            const {list_tags, tags, ...rest} = filter

            const cloneFilterExp = Object.assign({}, rest, filterTags)

            delete cloneFilterExp['created']
            delete cloneFilterExp['generated']
            delete cloneFilterExp['barcodeNumber']

            if (filter.created.hasOwnProperty('from')) {
                cloneFilterExp['created[from]'] = filter.created.from
            }

            if (filter.created.hasOwnProperty('to')) {
                cloneFilterExp['created[to]'] = filter.created.to
            }

            if (filter.generated.hasOwnProperty('from')) {
                cloneFilterExp['generated[from]'] = filter.generated.from
            }

            if (filter.generated.hasOwnProperty('to')) {
                cloneFilterExp['generated[to]'] = filter.generated.to
            }

            if (filter.barcodeNumber.hasOwnProperty('$gte')) {
                cloneFilterExp['barcodeNumber[$gte]'] = filter.barcodeNumber['$gte']
            }

            if (filter.barcodeNumber.hasOwnProperty('$lte')) {
                cloneFilterExp['barcodeNumber[$lte]'] = filter.barcodeNumber['$lte']
            }

            if (filter.hasOwnProperty('generate_label_config.delay_days')) {
                if (filter['generate_label_config.delay_days'].hasOwnProperty('from')) {
                    cloneFilterExp['generate_label_config.delay_days[from]'] = filter['generate_label_config.delay_days'].from
                    delete cloneFilterExp['generate_label_config.delay_days']
                }

                if (filter['generate_label_config.delay_days'].hasOwnProperty('to')) {
                    cloneFilterExp['generate_label_config.delay_days[to]'] = filter['generate_label_config.delay_days'].to
                    delete cloneFilterExp['generate_label_config.delay_days']
                }
            }

            if(filter.is_fba) {
                if(filter.is_fba === 'TikTok'){
                    cloneFilterExp.is_tiktok = 'y'
                    delete cloneFilterExp.is_fba
                }else if(filter.is_fba === 'n'){
                    cloneFilterExp.is_tiktok = 'n'
                }
            }

            if (filter.hasOwnProperty('products.overtimeLte')) {
                cloneFilterExp['products.overtime[$lte]'] = parseFloat(filter['products.overtimeLte'])
                delete cloneFilterExp['products.overtimeLte']
            }
        
            if (filter.hasOwnProperty('products.overtimeGt')) {
                cloneFilterExp['products.overtime[$gt]'] = parseFloat(filter['products.overtimeGt'])
                delete cloneFilterExp['products.overtimeGt']
            }

            if(cloneFilterExp.photo_requested) cloneFilterExp.request_photo_statuses = [cloneFilterExp.photo_requested]
                      
            const cleanFilter = cleanObjectShallow({...cloneFilterExp})
            window.location.href = getExportOrdersCSVv41({...cleanFilter})
            // console.log(filter);
        } catch (e) {
            alert(e.toString())
        }
    }

    render() {
        return (
            <Button className="btn-labeled btn-labeled-left" onClick={this._exportOrders} color="primary">
                <b><i className="mi-cloud-upload"/></b>
                Export Orders
            </Button>
        )
    }
}

ExportOrders.propTypes = {
    filter: PropTypes.object.isRequired
}

export default ExportOrders
